import React from "react";

export default function RegisterPage() {
  return (
    <div>
      <p>Register Page</p>
    </div>
  );
}
